module.exports = __webpack_public_path__ + "static/img/logo.e9a2b9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 0